import { BaseAction } from "../../../core/actions/BaseAction";
import { getRecoilStateValue, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { AncillaryStatusEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IOnChangeAddonForActivePassenger } from "../../../Orchestrator/Types/Interface/ActionParams/GetAddonsParams";
import { IAlreadyAddonsLegPassengerAddons } from "../../../Orchestrator/Types/Interface/IAddOns";

export class OnChangeAddonForActivePassenger extends BaseAction<
  IDefaultActionResult,
  IOnChangeAddonForActivePassenger
> {
  override async run(): Promise<IDefaultActionResult | null> {
    const actionResult: IDefaultActionResult = {
      data: null,
      message: "",
      status: "fail",
    };
    try {
      let { addonsPassengerList, legId, selectedAddon, event, category } =
        this.params!;
      const isManageSeating = getRecoilStateValue("isManageSeatingAtom")
      const alreadyAddonsLegPassenger: IAlreadyAddonsLegPassengerAddons | undefined = getRecoilStateValue("alreadyAddonsLegPassengerAtom")
      const allWayAlreadyAddons = [...(alreadyAddonsLegPassenger?.["outbound"] || []), ...(alreadyAddonsLegPassenger?.["inbound"] || [])]
      addonsPassengerList = [...addonsPassengerList].map(({ ...legPass }) => {
        if (legId === legPass.legId) {
          legPass.addonsPassenger = [...(legPass?.addonsPassenger || [])].map(
            ({ ...p }) => {
              if (p.isActive) {
                const existing = allWayAlreadyAddons.find(d =>
                  d.passengerId === p.passengerId &&
                  d.legId === legId &&
                  d.addonName === selectedAddon.label
                );
                // Stamp isPrebooked on the stored item so the Extras summary
                // in ManageSeatingAndAddons can render the "NEW" tag via a
                // single positive rule: only items that are (or will become)
                // PREBOOKED ancillaries are flagged. FULFILLED / REFUNDED
                // items are preserved as-is by PersistAddonsOnConfirmAction.
                // Fresh toggles (no matching existing) will be POSTed and
                // become PREBOOKED, so they also count as prebooked here.
                const isNewAddons = !Boolean(existing);
                const isPrebooked =
                  isNewAddons || existing?.status === AncillaryStatusEnum.PREBOOKED;
                if (event.target.checked) {
                  p.addonItem = {
                    ...p.addonItem,
                    [category]: { ...selectedAddon, isNew: isNewAddons, isPrebooked },
                  };
                } else {
                  const { [category]: _, ...rest } = p.addonItem;
                  p.addonItem = rest;
                }
              }
              return p;
            }
          );
        }
        return legPass;
      });
      updateRecoilState("addonsPassengerListAtom", addonsPassengerList);

      //Calculate addons price
      const selectLegForAddons =
        addonsPassengerList.find((d) => d.legId === legId)?.addonsPassenger ||
        [];
      let legAddonsPrice: number = 0;
      if (selectLegForAddons.length > 0) {
        selectLegForAddons.forEach((pass) => {
          Object.keys(pass.addonItem).forEach((key) => {
            legAddonsPrice += pass.addonItem[key]?.price || 0;
          });
        });
      }

      updateRecoilState("selectedLegAddonsPriceAtom", legAddonsPrice);

      actionResult.status = "success";
    } catch (error: any) {
      console.log("error", error);
      actionResult.message = error.message;
    } finally {
      return actionResult;
    }
  }
}

export const onChangeAddonForActivePassenger =
  new OnChangeAddonForActivePassenger();
